import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { List } from '@xsolla/ui-core';

import { ListWrapper, OptionsWrapper } from './style';
import { FieldTypes } from './types';

type Props = {
  visible: boolean;
  closeList: () => void;
  setFieldType: (field: string) => void;
};

export const FieldOptions = ({ visible, setFieldType, closeList }: Props): JSX.Element => {
  const intl = useIntl();
  const listItemHandle = (field: string) => {
    setFieldType(field);
    closeList();
  };

  const fieldList = useMemo(() => {
    return Object.keys(FieldTypes).reduce(
      (acc, key) => [
        ...acc,
        {
          children: intl.messages[`user-data-base.settings.supplementary-info.field-type.${key}`],
          onClick: () => listItemHandle(key)
        }
      ],
      []
    );
  }, []);

  return (
    <OptionsWrapper>
      {visible ? (
        <ListWrapper>
          <List items={fieldList} />
        </ListWrapper>
      ) : null}
    </OptionsWrapper>
  );
};
